<div class="flex bg-surface-switch-0">
  <div
    class="w-full md:w-6/12 px-12 py-20 md:px-20 flex flex-col gap-8 min-h-160 justify-center"
  >
    <div>
      <p-tag severity="success" value="404"></p-tag>
    </div>
    <div class="flex flex-col gap-4">
      <h1 class="text-5xl font-bold text-surface-switch-900 leading-tight">
        Page Not Found
      </h1>
      <p class="text-lg text-surface-switch-500 leading-normal">
        Sorry, we couldn't find the page.
      </p>
    </div>
    <div class="flex items-center gap-6">
      <button
        pButton
        [text]="true"
        class="text-base! leading-normal!"
        (click)="goBack()"
      >
        <i pButtonIcon class="pi pi-arrow-left"></i>
        <span pButtonLabel>Go Back</span>
      </button>
      <button pButton class="text-base! leading-normal!" routerLink="/quotes">
        <i pButtonIcon class="pi pi-file"></i>
        <span pButtonLabel>Go to Quotes</span>
      </button>
    </div>
  </div>
  <div
    class="w-full md:w-6/12 hidden md:block"
    style="
      background:
        linear-gradient(
          0deg,
          var(--p-primary-500) 0%,
          var(--p-primary-500) 100%
        ),
        url(&quot;https://fqjltiegiezfetthbags.supabase.co/storage/v1/object/public/block.images/blocks/pagenotfound/pagenotfound-split.jpg&quot;)
          lightgray 50% / cover no-repeat;
      background-blend-mode: overlay, normal;
    "
  ></div>
</div>
